export const GET_DISCOVERY_CATEGORIES = 'GET_DISCOVERY_CATEGORIES';
export const GET_DISCOVERY_CATEGORIES_SUCCESS = 'GET_DISCOVERY_CATEGORIES_SUCCESS';
export const GET_DISCOVERY_CATEGORIES_FAILED = 'GET_DISCOVERY_CATEGORIES_FAILED';
export const CLEANUP_DISCOVERY_CATEGORIES = 'CLEANUP_DISCOVERY_CATEGORIES';

export const GET_DISCOVERY_CATEGORY_DETAILS = 'GET_DISCOVERY_CATEGORY_DETAILS';
export const GET_DISCOVERY_CATEGORY_DETAILS_SUCCESS = 'GET_DISCOVERY_CATEGORY_DETAILS_SUCCESS';
export const GET_DISCOVERY_CATEGORY_DETAILS_FAILED = 'GET_DISCOVERY_CATEGORY_DETAILS_FAILED';
export const CLEANUP_DISCOVER_CATEGORY_DETAILS = 'CLEANUP_DISCOVER_CATEGORY_DETAILS';
